<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="ac !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.exercises') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="(ac.not_yet_started || ac.is_template) && inEdit !== true && all.length > ac.exerciseversions.length">
          <button [withRight]="'admin.' + mode + '.edit'" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
        </div>
    </div>

    <p-table *ngIf="inEdit === true || ac.exerciseversions?.length > 0" [value]="ac.exerciseversions">
        <ng-template pTemplate="header">
            <tr>
                <th>{{ t('common.labels.exercise') }}</th>
                <th style="width: 10rem;"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-exerciseversion>
            <tr>
              <td><p>{{ exerciseversion.exercise.name }}</p></td>
              <td style="vertical-align: top; text-align: right">
                <span *ngIf="inEdit !== true">
                  <button [withRight]="'admin.' + mode + '.edit'" *ngIf="ac.not_yet_started || ac.is_template" pButton (click)="onDelete(exerciseversion.exercise)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" aria-label="{{ t('common.labels.delete') }}"></button>
                </span>
              </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr *ngIf="inEdit === true">
            <ng-template [ngTemplateOutlet]="tForm"></ng-template>
          </tr>
        </ng-template>
    </p-table>

    <ng-template #tForm>
      <td style="vertical-align: top;">
        <app-form-control [cid]="'exercise'" [control]="form.get('exercise')" [type]="'select'" [options]="optionsExercises" [optionLabel]="'name'" [label]="''"></app-form-control>
      </td>
      <td style="vertical-align: top; text-align: right">
        <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
      </td>
    </ng-template>

    <p *ngIf="inEdit !== true && ac.exerciseversions?.length === 0">{{ t('common.texts.no_exercises') }}</p>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.delete')"
    [mode]="'template'"
    [(visible)]="deleteInheritVisible"
    (okClicked)="deleteExercise($event)"
  ></app-inherit-dialog>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'template'"
    [(visible)]="saveInheritVisible"
    (okClicked)="saveExercise($event)"
  ></app-inherit-dialog>


</ng-container>
